import { ptBR, enGB } from 'date-fns/locale'

export const dateLocales = {
  en: enGB,
  'pt-BR': ptBR,
}
